import { render, staticRenderFns } from "./InputPercentage.vue?vue&type=template&id=124c1298&scoped=true"
import script from "./InputPercentage.vue?vue&type=script&lang=js"
export * from "./InputPercentage.vue?vue&type=script&lang=js"
import style0 from "./InputPercentage.vue?vue&type=style&index=0&id=124c1298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124c1298",
  null
  
)

export default component.exports